import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import { FullMasterTemplate } from '@/modules/@appbase/templates'
import GnbLeftView from '@gnb/views/GnbLeft/GnbLeftView.vue';
import DesignPersonal from '@webparts/components/template-design/TemplateDesignPersonal.vue'
import * as typesWebpart from '@webparts/store/types';
import { WebpartDataType } from '@webparts/types/enums';

@Component({
  components: { FullMasterTemplate, DesignPersonal, GnbLeftView },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({
      loadCommonInfo: typesWebpart.WEBPART_COMMONDATA,
    }),
  },
})
export default class WebpartPersonalView extends Vue {
  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: A C T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  loadCommonInfo!: (types: WebpartDataType[]) => Promise<any>;

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  created() {
    this.loadCommonInfo([WebpartDataType.UnreadMail, WebpartDataType.MonthlyEvent, WebpartDataType.DailyEvent]);
  }
}
